export type Result<T, E> =
  | Readonly<{ ok: true; value: T }>
  | Readonly<{ ok: false; error: E }>;

export const ok = <T>(value: T): Result<T, never> => ({ ok: true, value });

export const err = <E>(error: E): Result<never, E> => ({ ok: false, error });

export const mapResult = <T, U, E>(
  result: Result<T, E>,
  mapper: (value: T) => U,
): Result<U, E> => (result.ok ? { ok: true, value: mapper(result.value) } : result);
